/**
 * 常规问答Mixin
 */
export default {
    methods: {
        /**
        * 新增提问
        * input 用户输入的内容（在对话中显示）
        * prompt 发给机器人学习的内容（不在对话中显示）
        * questionTime 提问时间
        */
        async addAsk (input, prompt, questionTime) {
            let askMsg = { role: 'user', content: input, questionTime };
            if (prompt) askMsg['notShowContent'] = prompt;
            this.currentChat.messages.push(askMsg);
            if (!this.historyMap[this.currentSessionId].title) this.editTitle(this.currentSessionId, input);
        },

        /**
         * 普通对话提问
         */
        commonAsk (data) {
            if (this.ui.typing) return;
            let prompt = data.input;
            let useLLM = this.useLLM;
            this.prompt = '';
            this.addAsk(prompt);

            // 文字提问
            // let msg = {
            //     'message': prompt,
            //     'model': useLLM,
            //     'ask': prompt,
            //     'useLLM': useLLM,
            //     'type': 'TEXT',
            //     'stop': ['\r\n\r\nHuman', '\r\nHuman', '\n\nHuman', '\nHuman'], // 流式停止标识
            //     contextLimit: this.modelSettings.contextLimit,
            //     temperature: this.modelSettings.temperature,
            //     maxLength: this.modelSettings.maxLength,
            //     maxToken: this.modelSettings.maxLength
            // };
            let sseMsg = {
                'message': prompt,
                'model': useLLM,
                'stop': ['\r\n\r\nHuman', '\r\nHuman', '\n\nHuman', '\nHuman'], // 流式停止标识
                contextLimit: this.modelSettings.contextLimit,
                temperature: this.modelSettings.temperature,
                maxTokens: this.modelSettings.maxLength
            };
            // 开始等待打字
            this.ui.typing = true;
            this.currentChat.messages.push({ role: 'assistant', content: '', feedback: null, finished: false });
            // this.socket.send(msg);
            this.sendSseStream(sseMsg);
        },

        /**
        * 从输入框内置对话逻辑，直接返回问答对
        */
        askAnswer (info) {
            let { title, input, answer, nospeech } = info;
            if (answer) {
                this.ui.typing = false;
                // 回答
                this.currentChat.messages.pop();
                this.currentChat.messages.push({ role: 'assistant', finished: true, thinking: false, content: answer, nospeech });
                // 保存上下文
                this.saveContext();
            } else {
                this.addAsk(input, null, Date.now());
                // 开始等待打字
                this.ui.typing = true;
                this.currentChat.messages.push({ role: 'assistant', content: '', feedback: null, thinking: true, finished: false, nospeech });
            }
        },

        /**
        * 从输入框内置对话逻辑，直接返回问答对，先输出问题，显示loading，等待输出答案
        */
        askAnswerLoading (info) {
            let { title, input, answer, nospeech } = info;

            this.addAsk(input, null, Date.now());

            // 回答
            this.ui.typing = true;
            this.currentChat.messages.push({ role: 'assistant', content: '', nospeech });

            // 回答loading
            let last = this.currentChat.messages[this.currentChat.messages.length - 1];
            let loadFunc = () => {
                if (this.ui.typing) {
                    let time = Date.now();
                    let str = '计算中，请稍候';
                    for (let i = 0; i < time % 6; i++) {
                        str += ' .';
                    }
                    this.$set(last, 'content', str);
                    setTimeout(loadFunc, 300);
                }
            };
            loadFunc();
        },

        /**
        * 从输入框内置对话逻辑，直接返回问答对，先输出问题，显示loading，等待输出答案
        */
        askAnswerFinish (info) {
            let { title, input, answer } = info;

            // 历史会话的标题
            if (!this.historyMap[this.currentSessionId].title) this.editTitle(this.currentSessionId, title || input);

            this.ui.typing = false;

            // 回答
            let last = this.currentChat.messages[this.currentChat.messages.length - 1];
            this.$set(last, 'finished', true);
            this.$set(last, 'content', answer);

            // 保存上下文
            this.saveContext();
        },

        /**
        * 隐含prompt的提问，input是用户输入的内容，prompt是发给机器人的内容，answerPrefix是回答前缀（用于限定返回内容用什么进行处理）
        */
        inputAsk (ask) {
            let { input, prompt, answerPrefix, nospeech } = ask;
            answerPrefix = answerPrefix || '';
            let useLLM = this.useLLM;

            this.addAsk(input, prompt);

            // 文字提问
            let msg = { 'ask': prompt, 'useLLM': useLLM, 'type': 'TEXT', contextLimit: this.modelSettings.contextLimit, temperature: this.modelSettings.temperature, maxLength: this.modelSettings.maxLength };
            this.socket.send(msg);

            // 开始等待打字
            this.ui.typing = true;
            this.mdTempStr = answerPrefix;
            this.currentChat.messages.push({ role: 'assistant', content: '', nospeech });
        }
    }
};
